export const AddNewVendorUserInfo: any =
{
    vendorRoleList: [
      {
        id: "36",
        vendorRoles: "Vendor Champion"
      },
      {
        id: "39",
        vendorRoles: "Vendor User"
      }
    ],
        vendorGroupList: [
      {
        id: "26",
        vendorGroups: "Vendor Champion User Group"
      },
      {
        id: "29",
        vendorGroups: "Vendor User Group"
      }
    ],
  }
  